import { getKindeInstance } from './kindeClient';

// Same-origin — Vercel proxies /api/* to the backend (see vercel.json).
const SERVER_URL = '';

async function readError(response) {
    // Server may return JSON ({message: ...}) or plain text. Don't crash
    // on response.json() when the body isn't JSON.
    const raw = await response.text();
    try {
        const json = JSON.parse(raw);
        return json.message || raw || `HTTP ${response.status}`;
    } catch (_) {
        return raw || `HTTP ${response.status}`;
    }
}

const checkUsernameUnique = async (username) => {
    const kinde = getKindeInstance();
    if (!kinde) throw new Error('Auth not ready. Please refresh and try again.');
    const token = await kinde.getToken();
    if (!token) throw new Error('Your sign-in expired. Please refresh and sign in again.');

    let response;
    try {
        response = await fetch(`${SERVER_URL}/api/user/username-check`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ username })
        });
    } catch (networkErr) {
        console.error('Network error checking username:', networkErr);
        if (typeof navigator !== 'undefined' && navigator.onLine === false) {
            throw new Error('You appear to be offline. Reconnect and try again.');
        }
        const detail = `${networkErr && networkErr.name || 'Error'}: ${networkErr && networkErr.message || 'unknown'}`;
        throw new Error(`Couldn't reach the server (${detail}). This is often caused by a browser privacy/ad-block extension blocking snordeluxe-server.vercel.app — try disabling it or use a different browser.`);
    }

    if (response.ok) return true;
    if (response.status === 400) return false;
    if (response.status === 401 || response.status === 403) {
        throw new Error('Your sign-in expired. Please refresh and sign in again.');
    }
    const detail = await readError(response);
    console.error(`username-check failed (${response.status}):`, detail);
    throw new Error(`Server error (${response.status}). ${detail}`);
};

const verifyAccessCode = async (accessCode) => {
    try {
        const kinde = getKindeInstance();
        const token = await kinde.getToken();
        const response = await fetch(`${SERVER_URL}/api/user/verify-access-code`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ code: accessCode })
        });
        const result = await response.json();
        if (!response.ok) {
            throw new Error(result.message || 'Verification failed');
        }
        return true;
    } catch (error) {
        console.error('Error verifying access code:', error);
        return false;
    }
};

const verifyBoostCode = async (boostCode) => {
    try {
        const kinde = getKindeInstance();
        const token = await kinde.getToken();
        const response = await fetch(`${SERVER_URL}/api/user/verify-boost-code`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ code: boostCode })
        });
        const result = await response.json();
        if (!response.ok) {
            throw new Error(result.message || 'Verification failed');
        }
        return result; // Return the entire result including rewards
    } catch (error) {
        console.error('Error verifying boost code:', error);
        throw error; // Ensure the error is thrown so the caller can handle it
    }
};

export { checkUsernameUnique, verifyAccessCode, verifyBoostCode };